import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "di_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 z-[80] mx-auto max-w-3xl rounded-2xl border border-[#E8E2E4] bg-white/95 p-6 shadow-[0_18px_60px_rgba(94,42,82,0.18)] backdrop-blur-xl sm:bottom-6"
    >
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center">
        <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#E0708A]/12 text-[#E0708A]">
          <Cookie size={20} />
        </span>
        <div className="flex-1">
          <p className="font-display text-lg text-[#1A1617]">
            Rispettiamo la tua privacy
          </p>
          <p className="mt-1 text-sm leading-relaxed text-[#6B5E62]">
            Usiamo cookie tecnici necessari al funzionamento del sito e, con il
            tuo consenso, cookie di statistica.{" "}
            <Link
              to="/cookie-policy"
              className="di-underline text-[#5E2A52]"
              data-testid="cookie-banner-policy-link"
            >
              Cookie policy
            </Link>
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={() => decide("necessary")}
            data-testid="cookie-reject-button"
            className="rounded-full border border-[#E8E2E4] px-5 py-2.5 text-sm font-medium text-[#6B5E62] transition-colors duration-300 hover:border-[#E0708A]"
          >
            Solo necessari
          </button>
          <button
            onClick={() => decide("all")}
            data-testid="cookie-accept-button"
            className="rounded-full bg-[#5E2A52] px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-[#E0708A]"
          >
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
};
